import { combineEpics } from 'redux-observable';

import { _reducer } from './ManageOrgTags.reducers';
import _epics from './ManageOrgTags.epics';

export const epics = combineEpics(_epics);

export { _reducer };
export * from './ManageOrgTags.actions';
